import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Spin } from 'antd';
import localStorage from '../../../../../utils/localStorage';

import { StyledHomepage } from '../../../../../commons/styles/layout';
import { MASTERIMAGES } from '../../../../../commons/api';

const ModulesList = (props) => {
  const userProfile = useSelector(state => state.LayoutReducer.loggedInProfile);
  const navigate = useNavigate();
  const moduleActions = {
    'Energy Management System': ['Modules', '51180', '51184'],
    'Gate Management System': ['Modules', '1156', '1158'],
    'Smart Lightning System': ['Modules', '51172', '51174'],
    'Marine Operations': ['Modules', '51164', '51166'],
    'Mobile Harbour Cranes': ['Modules', '51068', '51070'],
    'Rule Engine': ['Modules', '11173'],
    'Berth Monitoring System': ['Modules', '198', '1100'],
    'Conveyor Belt Monitoring': ['Modules', '51140', '51142'],
    'Shiploader': ['Modules', '51116', '51118'],
    'QC Monitoring': ['Modules', '1136', '1138'],
    'RTG Cranes Monitoring': ['Modules', '51126', '51128'],
    'Wind Turbine': ['Modules', '1246', '1250'],
    'AMM': ['Modules', '11219', '11221'],
    'Quay Cranes': ['Modules', '51040', '51044'],
    'Crane Monitoring System': ['Modules', '51228', '51230'],
    'Trend Analysis': ['Modules', '51372'],
  };

  const onClick = (craneObject, moduleName) => {
    if (moduleName && moduleActions[moduleName]) {
      props.layoutAction.setMenuSelection(moduleActions[moduleName]);
      navigate(craneObject);
    }
  };

  const site = localStorage.get('currentSite');

  if (!userProfile?.belongsTo?.sites?.[site]) {
    return (
      <div style={{ textAlign: 'center', marginTop: '30vh' }}>
        <Spin size="large" tip="Loading..." />
      </div>
    );
  }

  const menu = userProfile.belongsTo.sites[site].role.Modules.children;

  return (
    <StyledHomepage>
      <div className="Items-list">
        <Row gutter={[16, 16]}>
          {menu &&
            Object.keys(menu).map((menuKey) => {
              const cardName = menu[menuKey].name;
              if (cardName === 'Equipment Overview') return null;
              return (
                <Col key={menuKey} span={6} className="columnStyle">
                  <Card
                    className="cardDesign"
                    title={cardName}
                    bordered={false}
                    onClick={() => onClick(menu[menuKey].path, cardName)}
                    style={{ borderRadius: 35, height: '100%' }}
                  >
                    <img
                      alt={'No Image'}
                      src={`${MASTERIMAGES.MasterImages}/${cardName}.png`}
                      width="100%"
                      height={250}
                      style={{ borderRadius: 10 }}
                    />
                  </Card>
                </Col>
              );
            })}
        </Row>
      </div>
    </StyledHomepage>
  );
};

export default ModulesList;
